import { useEffect, useState } from "react";
import { useDataProvider, useRecordContext } from "react-admin";
import { Typography } from "@material-ui/core";

const WaveField = () => {
  const [waveName, setWaveName] = useState<string>();

  const record = useRecordContext();
  const provider = useDataProvider();

  const getWaveNameFromBusSchedulePlanId = async (
    busSchedulePlanId: number,
  ) => {
    if (!busSchedulePlanId) {
      return "-";
    }

    const { data: busSchedulePlanData } = await provider.getOne(
      "busSchedulePlans",
      {
        id: busSchedulePlanId,
      },
    );

    const { data: busScheduleData } = await provider.getOne("busSchedules", {
      id: busSchedulePlanData.busScheduleId,
    });

    return busScheduleData.name;
  };

  useEffect(() => {
    if (record.busSchedulePlanId) {
      getWaveNameFromBusSchedulePlanId(Number(record.busSchedulePlanId)).then(
        (waveName) => {
          setWaveName(waveName);
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  return <Typography variant="body2">{waveName}</Typography>;
};

export default WaveField;
